import { type RefObject, useEffect, useRef } from "react";
// biome-ignore lint/style/noRestrictedImports: encapsulation
import type { ImpulseForm } from "react-impulse-form";

import { useHandler } from "~/tools/use-handler";

export function useOnInvalidFormFocus<TRef extends { focus: VoidFunction }>(
	form: undefined | ImpulseForm,
	onFocus?: (ref: TRef) => void,
): RefObject<TRef> {
	const ref = useRef<TRef>(null);
	const onFocusStable = useHandler(onFocus);

	useEffect(() => {
		const target = ref.current;

		if (form != null && target != null) {
			return form.onFocusWhenInvalid(() => {
				target.focus();
				onFocusStable?.(target);
			});
		}
	}, [form, onFocusStable]);

	return ref;
}
